import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';

import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { DeeplinkFilterParams, HotelSearchPayload } from '@hotels/hotel-results/entities/hotel-search.payload';
import { HotelFiltersPayload } from '@hotels/hotel-results/entities/hotel-filters.payload';
import { HotelSearchResponse } from '@hotels/hotel-results/entities/hotel-search.response';
import { HotelFilterSearchPayload } from '@hotels/hotel-results/entities/hotel-filter-search.payload';
import { HotelFiltersPayloadState } from '@hotels/hotel-results/store/reducers/hotel-filters-payload.reducer';
import { FilterSorterCriterias } from '@shared/filters/entities/fetch-filters.response';
import { ZoneResponse, TopZonesPayload } from '@app/entities/zones.response';
import { HotelSearchLocation } from '@hotels/hotel-results/entities/hotel-search-location';
import { HotelFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';

export const searchHotelsAction = createAction(type('[Hotels/API] Search hotels'),
  props<{ payload: HotelSearchPayload, filters: DeeplinkFilterParams, isByhours?: boolean, hourType: string[] }>());
export const searchHotelsSuccessAction = createAction(type('[Hotels/API] Search hotels success'),
  props<{ response: HotelSearchResponse, session: string }>());
export const searchHotelsMarkersAction = createAction(type('[Hotels/API] Search hotels markers'),
  props<{ payload: HotelFiltersPayloadState }>());
export const searchHotelsMarkersSuccessAction = createAction(type('[Hotels/API] Search hotels markers success'),
  props<{ response: HotelSearchResponse, session: string }>());
export const searchLocationHotelAction = createAction(type('[Hotels/API] Search location hotel'),
  props<{ payload: HotelSearchLocation, isByhours?: boolean }>());
export const searchLocationHotelSuccessAction = createAction(type('[Hotels/API] Search location hotel success'),
  props<{ payload: HotelSearchLocation }>());
export const fetchHotelFiltersAction = createAction(type('[Hotels/API] Fetch hotel filters'),
  props<{ payload: HotelFiltersPayload }>());
export const fetchHotelFiltersSuccessAction = createAction(type('[Hotels/API] Fetch hotel filters success'),
  props<{ filters: HotelFiltersResponse }>());
export const fetchHotelsWithFiltersAction = createAction(type('[Hotels/API] Fetch hotels with filters'),
  props<{ payload: HotelFilterSearchPayload }>());
export const fetchHotelsMarkersWithFiltersAction = createAction(type('[Hotels/API] Fetch hotels markers with filters'),
  props<{ payload: HotelFilterSearchPayload }>());
export const fetchHotelsWithFiltersSuccessAction = createAction(type('[Hotels/API] Fetch hotels with filters success'),
  props<{ hotels: HotelSearched[] }>());
export const fetchHotelsMarkersWithFiltersSuccessAction =
  createAction(type('[Hotels/API] Fetch hotels markers with filters success'), props<{ hotels: HotelSearched[] }>());
export const clearHotelResultsAction = createAction(type('[Hotels/DATA] Clear hotel results'));
export const fetchHotelsWithPaginationAction = createAction(type('[Hotels/API] Fetch hotels with pagination'),
  props<{ payload: HotelFilterSearchPayload }>());
export const fetchHotelsWithPaginationSuccessAction = createAction(type('[Hotels/API] Fetch hotels with pagination success'),
  props<{ hotels: HotelSearched[] }>());
export const fetchHotelsExclusiveOfferSuccessAction = createAction(type('[Hotels/API] Fetch hotels exclusive offer success'),
  props<{ hotels: HotelSearched[] }>());
export const searchHotelsErrorAction = createAction(type('[HotelResults/Data] HotelResults error'),
  props<{ payload: HttpErrorResponse }>());
export const setFilterSorterAction = createAction(type('[HotelResults/Data] Set Filter Sorter'),
  props<{ payload: FilterSorterCriterias }>());
export const fetchHotelTopZonesAction = createAction(type('[Hotels/API] Fetch hotel top zones'),
  props<{ payload: TopZonesPayload }>());
export const fetchHotelTopZonesSuccessAction = createAction(type('[Hotels/API] Fetch hotel top zones Success'),
  props<{ zones: ZoneResponse[] }>());
export const disableHotelResultScrollAction = createAction(
  type('[HotelResults/UI] Disabled hotel results scroll'),
  props<{ payload: boolean }>()
);
